/* Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and */
/* matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, */
/* including without limitation, material generated from the software programs which are displayed on the screen such */
/* as icons, screen display looks, etc. */

export class IconSettings {
  public static colors = {
    options: [
      'indigo-500',
      'navy-500',
      'purple-500',
      'fuchsia-500',
      'orange-500',
      'green-500',
      'cerulean-500',
      'steel-500',
      'stone-500',
      'onyx-500',
    ],
  };

  public static glyphs = {
    options: [
      'xgl-accessibility',
      'xgl-accounting',
      'xgl-activity',
      'xgl-airplane',
      'xgl-annotate',
      'xgl-annotate_format_style',
      'xgl-announcement',
      'xgl-bates_stamp',
      'xgl-bell',
      'xgl-billing_usage_sheets',
      'xgl-blocks',
      'xgl-book_copy_both',
      'xgl-briefcase',
      'xgl-calendar',
      'xgl-camera',
      'xgl-car_side',
      'xgl-checklist_rtl',
      'xgl-cloud',
      'xgl-color_effects',
      'xgl-compass_tool',
      'xgl-computer',
      'xgl-confirmation_report',
      'xgl-convert_handwriting',
      'xgl-cube',
      'xgl-dashboard',
      'xgl-droplet',
      'xgl-eco',
      'xgl-globe_earth',
      'xgl-lightbulb',
      'xgl-marker',
      'xgl-mfd',
      'xgl-output',
      'xgl-paint_brush',
      'xgl-rocket',
      'xgl-scale_balance',
      'xgl-speech',
      'xgl-stethoscope',
      'xgl-teamwork',
      'xgl-translate',
      'xgl-user_check_on',
    ],
  };

  static getDefault() {
    return {
      image: '',
      glyph: 'xgl-accessibility',
      color: 'indigo-500',
    };
  }
}

export interface Icon {
  image: string;
  glyph: string;
  color: string;
}

export enum IconSize {
  Small,
  Large,
}

export interface IconSettingsType {
  colors: {
    options: string[];
  };
  glyphs: {
    options: string[];
  };
  selected?: Icon;
}
